export default __webpack_public_path__ + "static/media/high_performance.bd828c34.png";